import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  updateAuditLogsSearchQuery,
  resetAuditLogsSearchQuery
} from '../../../actions/components/audit-log-search';

const initialState = {
  query: {}
};

const onChangeAuditLogSearchQueryHandler = action => ({
  [action.toString()]: (state, { payload: query }) => set(`query`, query, state)
});

const onResetAuditLogSearchQueryHandler = action => ({
  [action.toString()]: set('query', {})
});

export default createReducer(initialState, {
  ...onChangeAuditLogSearchQueryHandler(updateAuditLogsSearchQuery),
  ...onResetAuditLogSearchQueryHandler(resetAuditLogsSearchQuery)
});
